import React from 'react';
import Navbar from '../components/profile-components/Navbar';
import Topbar from '../components/profile-components/Topbar';

function Email() {
  return (
    <>
      <Navbar />
      <Topbar />
      <div className="main-content">
        <h1>Email Page</h1>
        <p>This is a placeholder for the Email page.</p>
      </div>
    </>
  );
}

export default Email;
